import { render, staticRenderFns } from "./department_follow.vue?vue&type=template&id=cff94b30&"
import script from "./department_follow.vue?vue&type=script&lang=js&"
export * from "./department_follow.vue?vue&type=script&lang=js&"
import style0 from "./department_follow.vue?vue&type=style&index=0&id=cff94b30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports